// extracted by mini-css-extract-plugin
module.exports = {"container":"ContainerWithHeader_container__9K_Q5","header":"ContainerWithHeader_header__2Ki_D","content":"ContainerWithHeader_content__3YRqf"};